import { memo } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Alert } from '@mint-lib/tw-components/patterns';

const NonIntegratedInfo: React.FC = () => {
  const { t } = useTranslation('@myn/integrations_v2');

  return (
    <div
      data-testid={'non-integrated-test-id'}
      className="h-full w-full border-t border-greyscale-grey20 p-6"
    >
      <Alert title={t('Information')} severity="info" variant="multiline">
        {t('Integrate the platform to be able to make some adjustments to it')}
      </Alert>
    </div>
  );
};

export default memo(NonIntegratedInfo);
